import React, { useEffect, useState } from 'react';
import { fetchAbnormalLogs } from '../../services/logApi';
import Pagination from '../base/Pagination';

export default function Log() {
  const [logAlimList, setLogAlimList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 10;

  useEffect(() => {
    const getLogsAlim = async () => {
      try {
        const token = localStorage.getItem("token");
        const logs = await fetchAbnormalLogs(token);
        setLogAlimList(logs);
      } catch (error) {
        console.error("로그 요청 실패:", error);
        alert("로그 목록을 가져오는 데 실패했습니다.");
      }
    };

    getLogsAlim();
  }, []);

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logAlimList.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(logAlimList.length / logsPerPage);

  return (
    <div className="logpage">
      <h1>이상 알림 로그</h1>
      <div className="log_box">
        <div className="table">
          <table>
            <colgroup>
                  <col width="10%" />
                  <col width="70%" />
                  <col width="20%" />
              </colgroup>
            <thead>
              <tr>
                <th>번호</th>
                <th>내용</th>
                <th>일시</th>
              </tr>
            </thead>
            <tbody>
              {currentLogs.length > 0 ? (
                currentLogs.map((log, index) => (
                  <tr key={log.id}>
                    <td>{indexOfFirstLog + index + 1}</td>
                    <td>{log.json_log}</td>
                    <td>{log.create_date?.slice(0, 19).replace('T', ' ')}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>로그가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
}
